
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getCreateTrainingtypeDtoFormGroup() {
return new FormGroup({
    name: new FormControl<string | undefined>('', [Validators.required, Validators.maxLength(100)]),
    active: new FormControl<boolean | undefined>(true),
    visibleForUser: new FormControl<boolean | undefined>(true),
})
;
}
      